import { validateCpfAndCnpj } from 'v2/helpers/cpfCnpj';
import * as Yup from 'yup';

const isSelected = (value: string) => value !== 'not-selected';

const nationalSchema = Yup.object().shape({
  name: Yup.string().required('O nome é obrigatório'),
  currency: Yup.number().required('O tipo da moeda é obrigatório'),
  type: Yup.string().required('O tipo da conta é obrigatório'),
  bank_id: Yup.string()
    .required('Por favor selecione um banco')
    .test('invalid', 'Por favor selecione um banco', isSelected),
  operation_id: Yup.string(),
  document_number: Yup.string()
    .required('Número de documento é obrigatório')
    .test('invalid', 'Por favor, digite um CPF ou CNPJ válido', validateCpfAndCnpj),
  agency: Yup.string()
    .required('Por favor informe o número da agência')
    .matches(/^\d+$/, 'Campo aceita apenas números'),
  agency_digit: Yup.string().matches(/^\d+$/, 'Campo aceita apenas números'),
  account: Yup.string().required('Por favor informe o número da conta').matches(/^\d+$/, 'Campo aceita apenas números'),
  account_digit: Yup.string()
    .required('Por favor informe o dígito da conta')
    .when('bank_id', {
      is: '001',
      then: Yup.string().matches(/[0-9xX]+$/, 'Campo aceita apenas números ou "X"'),
      otherwise: Yup.string().matches(/^\d+$/, 'Campo aceita apenas números')
    })
});

const foreignSchema = Yup.object().shape({
  name: Yup.string().required('O nome é obrigatório'),
  currency: Yup.number().required('O tipo da moeda é obrigatório'),
  type: Yup.string().required('O tipo da conta é obrigatório'),
  bank_id: Yup.string()
    .required('Por favor selecione um banco')
    .test('invalid', 'Por favor selecione um banco', isSelected),
  operation_id: Yup.string(),
  document_number: Yup.string().required('Número de documento é obrigatório'),
  agency: Yup.string()
    .required('Por favor informe o número da agência')
    .matches(/^\d+$/, 'Campo aceita apenas números'),
  account: Yup.string().required('Por favor informe o número da conta').matches(/^\d+$/, 'Campo aceita apenas números'),
  notes: Yup.string()
});

export const getSchema = (isForeign: boolean) => (isForeign ? foreignSchema : nationalSchema);
